import { useMemo } from 'react';
import type { JSX, PropsWithChildren } from 'react';

import { Elements } from '@stripe/react-stripe-js';
import { loadStripe } from '@stripe/stripe-js';

import { useUtilityContext } from '@change-corgi/core/react/utilityContext';

import stripeConfig from 'config/stripe.json';

export function StripeLoader({ children }: PropsWithChildren<EmptyProps>): JSX.Element {
	const utilityContext = useUtilityContext();

	const environment = utilityContext.environment.getEnvironment();
	const stripePromise = useMemo(async () => loadStripe(stripeConfig.key[environment]), [environment]);

	return <Elements stripe={stripePromise}>{children}</Elements>;
}
